import { Injectable, inject } from '@angular/core';
import { Subject, debounceTime } from 'rxjs';
import { LoadingService } from '../../shared/services/loading.service';

@Injectable({ providedIn: 'root' })
export class InterceptorService {
  private calls = 0;
  private cont = 0;
  private hideLoaderSubject = new Subject<void>();
  private readonly DEBOUNCE_TIME = 250;
  private readonly _loadingService = inject(LoadingService);

  constructor() {
    this.hideLoaderSubject.pipe(debounceTime(this.DEBOUNCE_TIME)).subscribe(() => {
      this._loadingService.hideLoader();
    });
  }

  showLoading(skipLoading: boolean): void {
    if (!skipLoading) {
      this.calls++;
      this._loadingService.showLoader();
    } else {
      this.cont++;
    }
  }

  hideLoading(skipLoading: boolean): void {
    if (!skipLoading) {
      this.calls--;
    } else {
      if (this.cont > 0) {
        this.cont--;
      } else {
        this.calls--;
      }
    }
    if (this.calls <= 0) {
      this.calls = 0;
      this.hideLoaderSubject.next();
    }
  }
}
